import { render, staticRenderFns } from "./ContactInfoStep.vue?vue&type=template&id=4efc98a1"
import script from "./ContactInfoStep.vue?vue&type=script&lang=ts"
export * from "./ContactInfoStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports